var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 4C6 2.89543 6.89543 2 8 2H16C17.1046 2 18 2.89543 18 4V5V6.2V16.8V18V20C18 21.1046 17.1046 22 16 22H8C6.89543 22 6 21.1046 6 20V18V16.8V6.2V5V4ZM16.8 6.2V16.8H7.2V6.2H16.8ZM7.2 19.8V18H16.8V19.8C16.8 20.3523 16.3523 20.8 15.8 20.8H8.2C7.64771 20.8 7.2 20.3523 7.2 19.8ZM16.8 5H7.2V4.2C7.2 3.64772 7.64772 3.2 8.2 3.2H15.8C16.3523 3.2 16.8 3.64772 16.8 4.2V5ZM13 19.4C13 19.9523 12.5523 20.4 12 20.4C11.4477 20.4 11 19.9523 11 19.4C11 18.8477 11.4477 18.4 12 18.4C12.5523 18.4 13 18.8477 13 19.4Z"}));
}

Phone.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Phone;

Phone.default = Phone;
